/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Benefits_Choose_VoicesInputs */

const en_mobile_benefits_choose_voices = /** @type {(inputs: Mobile_Benefits_Choose_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose from 20 voices`)
};

const es_mobile_benefits_choose_voices = /** @type {(inputs: Mobile_Benefits_Choose_VoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige entre 20 voces`)
};

/**
* | output |
* | --- |
* | "Choose from 20 voices" |
*
* @param {Mobile_Benefits_Choose_VoicesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_benefits_choose_voices = /** @type {((inputs?: Mobile_Benefits_Choose_VoicesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Benefits_Choose_VoicesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_benefits_choose_voices(inputs)
	return en_mobile_benefits_choose_voices(inputs)
});